








































import { SystemEvent } from '@/common/bot/enum';
import { ActionSelectedEvent, ArticleSystemOption, SystemArticleCheckFailureMessage, SystemOptionEvent } from '@/common/bot/types';
import FaAngleRight from '@/components/icons/FaAngleRight.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    FaAngleRight,
  },
})
export default class ArticleCheckFailureMessage extends Vue {
  @Prop({ default: () => ({}) }) readonly message!: SystemArticleCheckFailureMessage;

  get article () {
    return this.message.article;
  }

  get articleAction () {
    return this.message.article.action;
  }

  buildArticleSelectedEvent (article: ArticleSystemOption) {
    const event: SystemOptionEvent = {
      type: SystemEvent.LIST_OPTION_SELECTED,
      message: this.message,
      payload: {
        selected: { ...article },
      },
    };

    this.$emit('send:event', event);
  }

  buildActionEvent () {
    if (!this.articleAction) return;
    const event: ActionSelectedEvent = {
      type: SystemEvent.ACTION_SELECTED,
      message: this.message,
      payload: { action: this.articleAction },
    };
    this.$emit('send:event', event);
  }
}
